// Genere par tools/gen-icons.mjs. Ne pas editer a la main.
import { createRemixIcon } from '../create-remix-icon.js';

export const IconMailSendEnvelope = createRemixIcon('IconMailSendEnvelope', "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 1.75h24v20.5H0zm2.5 6.207V19.75h19V7.957l-9.021 4.92l-.479.262l-.479-.261z\" clip-rule=\"evenodd\"/>");
